export default "__VITE_ASSET__BIyI3q8Q__"